import { render, staticRenderFns } from "./SimCardDetails.vue?vue&type=template&id=101cd10a&scoped=true&"
import script from "./SimCardDetails.vue?vue&type=script&lang=js&"
export * from "./SimCardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101cd10a",
  null
  
)

export default component.exports